import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './user-profile-form.scss';
import { Form } from '@ampol/design-system';
import { getUserDetails, updateUserProfileSelf, updateUserProfileSelfReset } from '../../actions/userActions';
import { userDetailsFormSchema } from 'schemas/user-schemas';
import { trackCustomEvent } from 'utilities/app-insights';

const UserProfileForm = ({ formId, setUpdateButtonEnabled }) => {
  const dispatch = useDispatch();

  const assignedGrandfatherClientNumber = useSelector((state) => state.userStore.assignedGrandfatherClientNumber);

  const userDetails = useSelector((state) => state.userStore.loggedInUser);
  const userDetailsLoading = useSelector((state) => state.userStore.loggedInUserLoading);
  const userDetailsLoaded = useSelector((state) => state.userStore.loggedInUserLoaded);

  const updateLoading = useSelector((state) => state.userStore.updateUserProfileSelfLoading);
  const updateLoaded = useSelector((state) => state.userStore.updateUserProfileSelfLoaded);

  const [defaultValues, setDefaultValues] = useState({});

  useEffect(() => {
    if (!userDetailsLoaded) {
      dispatch(getUserDetails());
    }

    return () => {
      dispatch(updateUserProfileSelfReset());
    };
  }, []);

  useEffect(() => {
    if (userDetailsLoaded || updateLoaded) {
      setDefaultValues({
        firstName: userDetails?.givenName,
        lastName: userDetails?.familyName,
        email: userDetails?.emailId,
      });
    }
  }, [userDetailsLoaded, updateLoaded]);

  const handleSubmit = (form) => {
    const updateUserProfileRequest = {
      ...userDetails,
      givenName: form.firstName,
      familyName: form.lastName,
    };

    dispatch(
      updateUserProfileSelf(
        updateUserProfileRequest.userId,
        assignedGrandfatherClientNumber,
        JSON.stringify(updateUserProfileRequest)
      )
    );

    trackCustomEvent('Submit Update Your Profile', userDetails, undefined, 'Clicked on Update to submit Update Your Profile.');
  };

  const handleStateChange = ({ isValid }) => {
    setUpdateButtonEnabled(isValid);
  };

  return (
    <div className="user-profile-form">
      {updateLoading || userDetailsLoading ? (
        <div>Loading...</div>
      ) : (
        <Form
          id={formId}
          schema={userDetailsFormSchema}
          onSubmit={handleSubmit}
          defaultValues={defaultValues}
          onStateChange={handleStateChange}
        >
          <div className="user-profile-form__section">
            <Form.Input name="email" label="Email" disabled={true} />
            <div className="user-profile-form__split-col">
              <Form.Input name="firstName" label="First Name" />
              <Form.Input name="lastName" label="Last Name" />
            </div>
          </div>
        </Form>
      )}
    </div>
  );
};

export default UserProfileForm;
